module.exports = __webpack_public_path__ + "static/4-343d413dc05afedb21a889888c555810.jpg";